import { render, staticRenderFns } from "./RequestCredentials.vue?vue&type=template&id=245dc03a&scoped=true"
import script from "./RequestCredentials.vue?vue&type=script&lang=js"
export * from "./RequestCredentials.vue?vue&type=script&lang=js"
import style0 from "./RequestCredentials.vue?vue&type=style&index=0&id=245dc03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245dc03a",
  null
  
)

export default component.exports